export const EmbedGoogleReviewsDashboardSx = {
  mainContainer: {
    display: 'flex',
    gap: '24px',
    width: '100%',
    marginTop: '16px',
    flexDirection: { xs: 'column-reverse', tg: 'inherit' }
  },
  addGoogleReviewsContainer: {
    width: { xs: '100%', tg: '40%' },
    minWidth: '398px',
    mb: 2
  },
  widgetPreviewContainer: {
    width: { xs: '100%', tg: '60%' },
    position: { xs: 'relative', tg: 'sticky' },
    top: { xs: 'unset', tg: '70px' },
    height: 'fit-content'
  },

  label: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  sliderLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  sliderValue: {
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    color: 'var(--color-primary)',
    lineHeight: 'var(--line-height-20)'
  },
  sliderWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  sliderBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  sliderBottomTexts: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  slider: {
    color: 'var(--color-primary)',
    '& .MuiSlider-thumb': {
      backgroundColor: 'var(--color-white)',
      border: '2px solid var(--color-primary)'
    },
    '& .MuiSlider-track': {
      backgroundColor: 'var(--color-primary)'
    },
    '& .MuiSlider-rail': {
      backgroundColor: 'var(--color-text-muted-purple)'
    }
  },
  templateWrapper: {
    display: 'flex',
    gap: '16px'
  },
  templateOption: {
    width: '50%',
    padding: '12px',
    borderRadius: '6px',
    borderWidth: '1px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px'
  },
  templateSelected: {
    border: '2px solid var(--color-primary)'
  },
  templateUnselected: {
    border: '1px solid var(--color-text-muted-purple)'
  },
  templateImg: {
    maxWidth: '144px'
  },
  radioSelectedText: {
    fontWeight: 500,
    fontSize: '12px',
    color: 'var(--color-primary)'
  },
  radioUnselectedText: {
    fontWeight: 400,
    fontSize: '12px',
    color: 'var(--color-text-dark)'
  },
  colorFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  colorBoxWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  colorPreview: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    cursor: 'pointer',
    border: '1px solid var(--color-border-light2)'
  },
  colorPopover: {
    position: 'relative',
    zIndex: 10
  },
  colorInput: {
    width: '240px'
  },
  fontSelect: {
    width: '100%'
  },
  switchWrapper: {
    margin: 0
  },
  switchLabel: {
    fontFamily: 'Inter',
    fontSize: '12px',
    color: 'var(--color-primary)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    marginLeft: '6px'
  },
  input: {
    marginTop: '4px'
  },
  validateBtn: {
    marginTop: '8px',
    maxHeight: '36px',
    gap: '6px',
    borderRadius: '6px',
    padding: '8px 12px 8px 12px',
    '& .MuiButton-startIcon': {
      margin: 0
    }
  },
  note: {
    marginTop: '8px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  publishBtn: {
    marginTop: '20px',
    maxHeight: '40px',
    gap: '8px',
    padding: '10px 18px 10px 18px',
    borderRadius: '6px'
  },
  inlineFieldWrapper: {
    display: 'flex',
    gap: '16px',
    width: '100%',
    flexWrap: { xs: 'wrap', sm: 'nowrap' }
  },
  halfField: {
    width: '100%'
  },
  spacing24: {
    marginTop: '24px'
  },
  spacing12: {
    marginTop: '12px'
  },
  labelSpacing: {
    marginBottom: '6px'
  },
  miniNote: {
    marginTop: '8px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  presetColorRow: {
    display: 'flex',
    gap: '12px',
    marginBottom: '12px',
    flexWrap: 'wrap'
  },
  presetColorCircle: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    cursor: 'pointer'
  },
  colorCircleInsideInput: {
    width: '24px',
    height: '24px',
    minWidth: '24px',
    minHeight: '24px',
    maxWidth: '24px',
    maxHeight: '24px',
    borderRadius: '50%',
    border: '1px solid var(--color-border-light2)',
    cursor: 'pointer',
    display: 'inline-block', // ✅ prevents flex/text stretching
    boxSizing: 'border-box' // ✅ ensures border doesn’t distort shape
  },
  validateBtnBox: {
    position: 'absolute',
    bottom: '8px',
    right: '0px',
    left: '8px',
    background: 'white',
    zIndex: 1,
    width: '92%'
  },

  previewHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2
  },

  viewSwitchButtonGroup: {
    display: 'flex',
    gap: '8px',
    backgroundColor: 'var(--color-white)',
    border: '1px solid var(--color-border)',
    borderRadius: '6px',
    padding: '2px'
  },

  totalReviewSummaryCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 3,
    py: 2,
    borderRadius: '12px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600
  },

  carouselWrapper: {
    marginTop: '16px',
    position: 'relative'
  },

  reviewerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  reviewerImage: {
    borderRadius: '50%',
    width: '32px',
    height: '32px'
  },

  reviewerDetails: {
    display: 'flex',
    flexDirection: 'column'
  },

  reviewStars: {
    fontSize: 'var(--font-size-16)',
    color: '#FBBF24',
    fontWeight: 600
  },

  reviewCarouselDots: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'center',
    gap: '6px'
  },

  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-border)',
    '&.active': {
      backgroundColor: 'var(--color-success-green2)'
    }
  },
  toggleButton: {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    fontFamily: 'Inter',
    px: '16px',
    borderRadius: '6px !important',
    color: 'var(--color-text-dark)',
    '&.Mui-selected': {
      border: '2px solid #0CAF60 !important',
      color: 'var(--color-success-green2)',
      backgroundColor: 'var(--color-bg-mint)'
    }
  },

  rateUsButton: {
    mt: '24px',
    alignSelf: 'center',
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    padding: '10px 18px',
    textTransform: 'none'
  },

  reviewTopRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  reviewFooterRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  mobileCarouselContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    mt: 2
  },
  carouselArrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    cursor: 'pointer',
    backgroundColor: 'var(--color-white)',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
    '& img': {
      width: '16px',
      height: '16px'
    }
  },

  carouselContainer: {
    marginTop: '16px',
    width: '100%',
    position: 'relative',
    '& .slick-slide': {
      paddingLeft: '8px', // space between cards
      paddingRight: '8px'
    },
    '& .slick-list': {
      marginLeft: '8px',
      marginRight: '8px'
    },
    '& .slick-dots': {
      marginTop: '16px'
    }
  },

  //new css

  formCard: {
    width: '100%',
    borderRadius: '12px'
  },
  formCardContent: {
    padding: '24px'
  },
  previewHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  header: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  toggleGroup: {
    display: 'flex',
    gap: '8px'
  },
  viewButton: {
    fontSize: 'var(--font-size-14)',
    textTransform: 'none',
    fontWeight: 500,
    fontFamily: 'Inter',
    px: '14px',
    py: '8px',
    borderRadius: '6px',
    border: '1px solid var(--color-border)'
  },
  summaryCard: {
    maxWidth: '652px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  summaryRating: {
    fontSize: 'var(--font-size-20)',
    fontWeight: 700
  },
  summaryButton: {
    width: '127px',
    height: '40px',
    borderRadius: '6px',
    padding: '10px 20px',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    textTransform: 'none',
    color: 'var(--color-white)'
  },
  reviewCount: {
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
  },
  desktopSliderWrapper: {
    marginTop: '32px',
    position: 'relative',
    '& .slick-slide': {
      paddingLeft: '8px',
      paddingRight: '8px'
    }
  },
  mobileSliderWrapper: {
    marginTop: '32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  reviewCard: {
    width: '100%',
    maxWidth: '209px',
    height: '218px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '6px',
    gap: '16px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  reviewCardHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  reviewText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    fontWeight: 400
  },
  readMore: {
    fontSize: '13px',
    color: 'var(--color-success-green2)',
    cursor: 'pointer',
    fontWeight: 500,
    ml: 1
  },
  reviewCardFooter: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  avatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%'
  },
  nameText: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    fontFamily: 'Inter'
  },
  timeText: {
    fontSize: '12px',
    color: 'var(--color-text-muted-purple)',
    fontFamily: 'Inter'
  },
  slickDotsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: '8px',
    marginTop: '16px'
  },
  slickDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    opacity: 0.5
  },
  arrowWrapperLeft: {
    position: 'absolute',
    top: '50%',
    left: '-36px',
    transform: 'translateY(-50%)',
    zIndex: 1,
    cursor: 'pointer'
  },
  arrowWrapperRight: {
    position: 'absolute',
    top: '50%',
    right: '-36px',
    transform: 'translateY(-50%)',
    zIndex: 1,
    cursor: 'pointer'
  },
  helpSmallIcon: {
    width: '16px',
    height: '16px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: 'var(--color-primary)'
    }
  }
};

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    padding: '10px 14px',
    borderRadius: '6px',
    border: '1px solid var(--color-border)',
    maxHeight: '46px',
    '&.Mui-error': {
      borderColor: 'var(--color-error-red)' // red border on error
    },
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& input': {
    padding: 0
  }
};

export const textAreaSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    border: '1px solid var(--color-border)',
    padding: '10px 14px',
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& textarea': {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    padding: 0,
    resize: 'none',
    paddingBottom: '40px'
  }
};

export const widgetPreviewSx = {
  wrapper: {
    borderRadius: '12px'
  },
  spacing: {
    px: '24px',
    py: '24px'
  },
  spacingExtraPy: {
    paddingLeft: '37px',
    paddingRight: '28px',
    //py: '32px',
    paddingTop: '32px',
    paddingBottom: '32px'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '16px'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  toggleButton: (selected: boolean) => ({
    height: '40px',
    px: '14px',
    py: '8px',
    border: selected ? '2px solid var(--color-secondary)' : '1px solid var(--color-border)',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    textTransform: 'none',
    cursor: 'pointer'
  }),
  summaryBox: (
    cardBgColor: string,
    textColor: string,
    starsColor: string,
    cardRadius: string
  ) => ({
    //width: '100%', //don't remove this
    height: '85px',
    px: '16px',
    py: '18px',
    borderRadius: cardRadius,
    backgroundColor: cardBgColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: textColor,
    fontFamily: 'Inter',
    marginLeft: 'auto',
    marginRight: 'auto',
    gap: '24px'
  }),
  summaryMobileBox: (
    cardBgColor: string,
    textColor: string,
    starsColor: string,
    cardRadius: string,
    view: string
  ) => ({
    width: {
      xs: view == 'mobile' ? '300px' : 'auto',
      sm: view == 'mobile' ? '300px' : 'auto'
    },
    px: '16px',
    py: '12px',
    borderRadius: cardRadius,
    backgroundColor: cardBgColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: textColor,
    fontFamily: 'Inter',
    marginLeft: 'auto',
    marginRight: 'auto',
    flexDirection: 'column'
  }),
  readMore: (textColor: string, font: string) => ({
    //color: 'rgba(32, 33, 36, 0.6)',
    color: textColor,
    textDecoration: 'underline',
    textDecorationThickness: '1.2px',
    cursor: 'pointer',
    textUnderlineOffset: '4px',
    //textDecorationColor: 'rgba(32, 33, 36, 0.6)'
    textDecorationColor: textColor,
    fontFamily: font,
    opacity: 0.9
  }),
  summaryMobileReviewBox: {
    flexDirection: 'column-reverse',
    marginTop: '8px',
    width: '100%'
  },
  summaryText: (textColor: string) => ({
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    //color: 'var(--color-near-black-grey)'
    color: textColor
  }),
  summarySpanText: (color: string, font: string) => ({
    fontFamily: font,
    fontWeight: 700,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    //color: 'var(--color-near-black-grey)'
    color: color
  }),
  summarySpanMobileText: (color: string, font: string) => ({
    fontWeight: 600,
    fontFamily: font,
    //color: 'var(--color-near-black-grey)'
    color: color
  }),
  reviewBox: (
    cardBgColor: string,
    textColor: string,
    isMobile: Boolean,
    cardRadius: string
  ) => ({
    minWidth: isMobile ? 'auto' : '260px',
    minHeight: '233px',
    borderRadius: cardRadius,
    backgroundColor: cardBgColor,
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    color: textColor,
    gap: '8px'
  }),
  reviewText: (textColor: string, font: string) => ({
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    fontWeight: 400,
    fontFamily: font,
    //fontFamily: 'Inter',
    //color: 'var(--color-near-black-grey)'
    color: textColor
  }),
  avatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%'
  },
  reviewerDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontSize: '12px',
    overflow: 'hidden'
  },
  reviewerName: (textColor: string, font: string) => ({
    //fontFamily: 'Inter',
    fontFamily: font,
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    //color: 'var(--color-near-black-grey)'
    color: textColor,
    whiteSpace: 'nowrap', //  keep text in single line
    overflow: 'hidden', // hide extra text
    textOverflow: 'ellipsis', //  show "..."
    maxWidth: '100%'
  }),
  reviewTime: (textColor: string, font: string) => ({
    fontFamily: font,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-20)',
    color: textColor,
    //color: 'rgba(32, 33, 36, 0.7)',
    opacity: 0.7
  }),
  //dotsContainer: (dotColor: string) => ({
  //  display: 'flex',
  //  justifyContent: 'center',
  //  gap: '8px',
  //  mt: 2,
  //  '& div': {
  //    width: '8px',
  //    height: '8px',
  //    borderRadius: '50%',
  //    backgroundColor: dotColor,
  //    opacity: 0.4
  //  },
  //  '& .active': {
  //    opacity: 1
  //  }
  //}),

  //dotsContainer: (dotColor: string) => ({
  //  display: 'flex',
  //  justifyContent: 'center',
  //  gap: '8px',
  //  mt: 2,
  //  '& li': {
  //    display: 'inline-block'
  //  },
  //  '& .review-dot': {
  //    width: '8px',
  //    height: '8px',
  //    borderRadius: '50%',
  //    backgroundColor: dotColor,
  //    opacity: 0.4,
  //    transition: 'opacity 0.3s ease'
  //  },
  //  '& .slick-active .review-dot': {
  //    opacity: 1
  //  }
  //}),

  navIcon: (color: string) => ({
    fontSize: '40px',
    color,
    cursor: 'pointer'
  }),
  rateUsBtn: {
    height: '40px',
    borderRadius: '6px',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    px: '20px',
    py: '10px',
    textTransform: 'none',
    whiteSpace: 'nowrap', //  keep text in single line
    overflow: 'hidden', //  hide extra text
    textOverflow: 'ellipsis', //  show "..."
    maxWidth: '100%' //  ensure it doesn’t grow beyond parent
  },
  toggleBtnText: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: 'var(--color-text-dark)'
  },
  badgeCard: {
    gap: '8px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '211px'
    //marginTop: '48px'
  },
  badgeReviewText: (textColor: string, font: string) => ({
    fontFamily: font,
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    //color: 'rgba(32, 33, 36, 1)',
    color: textColor,
    marginTop: '4px'
  }),
  absoluteArrow: (direction: 'left' | 'right', color: string) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    [direction]: '-25px', // negative to make half-outside
    color,
    fontSize: 'var(--font-size-32)',
    cursor: 'pointer',
    zIndex: 2
  }),
  carouselTemplateMainBox: {
    position: 'relative',
    //width: 'max-content',
    //marginLeft: 'auto',
    marginRight: 'auto',
    marginLeft: '-6px'
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  noReviews: (textColor: string) => ({
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: textColor,
    marginTop: '12px',
    textAlign: 'center'
  }),
  cardContent: { padding: '0px', paddingBottom: '0px !important' },
  dotsContainer: (accentColor: string) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    mt: 2,
    '.review-dot': {
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: 'var(--color-border-light2)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&.active': {
        backgroundColor: accentColor,
        transform: 'scale(1.2)'
      }
    }
  }),
  titleTooltipBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  arrowBoxSx: (direction: 'left' | 'right', bgColor: string) => ({
    // Position and size the Box itself
    [direction]: '-11px !important',
    width: '30px', // Use the icon's size for the box width
    height: '30px', // Use the icon's size for the box height
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: bgColor, // This will be the color of the circle background
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
      backgroundColor: bgColor
    }
  }),
  arrowIconSx: (accentColor, fontSize) => ({
    color: accentColor, // This changes the arrow to white
    fontSize,
    '&:hover': {
      color: accentColor, // Change this to the color you want on hover
      // You can add other properties here, like opacity, background, etc.
      opacity: 0.8 // Example: make it slightly transparent on hover
    },
    '&:active': {
      // **The click effect** - change color and opacity only
      color: `darken(${accentColor}, 20%)`, // Use a darker shade for the click effect
      opacity: 0.6
    }
  })
};

export const EmbedYourWidgetModalSx = {
  container: {
    padding: '32px',
    width: '100%'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    textAlign: 'center'
  },
  codeBox: {
    border: '1px solid var(--color-text-muted-purple)',
    borderRadius: '6px',
    fontFamily: 'Inter',
    //whiteSpace: 'pre-wrap',
    //wordWrap: 'break-word',
    padding: '10px 14px 10px 14px',
    marginBottom: '6px',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  imageContainer: {
    position: 'relative',
    mt: 2,
    mb: 3
  },
  thumbnail: {
    width: '100%',
    borderRadius: '10px'
  },
  playIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: 64,
    color: 'white',
    opacity: 0.85
  },
  footerButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '24px',
    gap: '12px',
    alignItems: 'center'
  },
  subtitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-purple)',
    marginTop: '14px',
    marginBottom: '12px'
  },
  videoBox: {
    marginTop: '24px',
    maxWidth: '486px',
    height: '274px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  iframe: {
    borderRadius: '7px',
    padding: '8px, 12px, 8px, 12px',
    gap: '8px'
  },
  button: {
    maxHeight: '44px',
    borderRadius: '6px',
    padding: '10px 18px 10px 18px',
    fontWeight: 500
  },
  noteTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-near-black-grey)',
    marginBottom: '24px'
  }
};

export const FilterPopoverSx = {
  label: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-black)'
  },
  publishBtn: {
    maxHeight: '40px',
    gap: '8px',
    padding: '10px 18px 10px 18px',
    borderRadius: '6px'
  }
};

export const WidgetsDashboardSx = {
  manageGoogleReviewsWidgetsSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  createNewWidgetBtn: {
    maxHeight: '44px',
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px'
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
};

export const WidgetsListSx = {
  wrapper: (selected: boolean, isBadge: boolean) => ({
    minHeight: { xs: '360px', sm: '320px' },
    maxHeight: { xs: '400px', sm: '320px' },
    //maxHeight: isBadge ? '240px' : { xs: '360px', sm: '320px' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    p: '16px 16px 16px 16px',
    borderRadius: '12px',
    border: `1px solid ${selected ? 'var(--color-primary)' : 'var(--color-text-muted-purple)'}`,
    cursor: 'pointer'
  }),
  widgetName: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    color: 'var(--color-primary)',
    mb: 1
  },
  iconBox: {
    width: '36px',
    height: '36px',
    borderRadius: '6px',
    border: '1px solid var(--color-text-muted-purple)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  copyBtn: {
    maxHeight: '36px',
    borderRadius: '6px',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500
  },
  templateImg: {
    maxWidth: '246px',
    maxHeight: '110px'
  },
  noWidgetBox: {
    width: '100%',
    marginTop: '16px'
  },
  noWidgetText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '17px',
    textAlign: 'center'
  }
};

export const WidgetDeleteModalSx = {
  deleteMultipleKeywordModal: {
    padding: '24px'
  },
  deleteMultipleKeywordTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    textAlign: 'left'
  },
  deleteMultipleKeywordDesc: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-15)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginTop: '8px'
  },
  deleteMultipleKeywordBtnBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    justifyContent: 'end'
  },
  deleteMultipleKeywordBtn: {
    gap: '6px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  deleteMultipleKeywordBtnTwo: {
    gap: '6px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px'
  }
};
